// Deterministic color palette for user avatars
// Colors are chosen to be distinguishable and work on both light/dark backgrounds
const PALETTE = [
	'#E57373', '#F06292', '#BA68C8', '#9575CD',
	'#7986CB', '#64B5F6', '#4FC3F7', '#4DD0E1',
	'#4DB6AC', '#81C784', '#AED581', '#FFD54F',
	'#FFB74D', '#FF8A65', '#A1887F', '#90A4AE',
];

export function getUserColor(userId: string): string {
	let hash = 0;
	for (let i = 0; i < userId.length; i++) {
		hash = ((hash << 5) - hash + userId.charCodeAt(i)) | 0;
	}
	return PALETTE[Math.abs(hash) % PALETTE.length]!;
}

// e.g. "john.doe@example.com" → "JD"
export function getInitials(email: string): string {
	const localPart = email.split('@')[0] ?? email;
	return localPart
		.split(/[._-]/)
		.filter(Boolean)
		.map((part: string) => part[0] ?? '')
		.join('')
		.toUpperCase()
		.slice(0, 2);
}
